import { combineReducers } from 'redux';

import Layout from './layout/reducer';

import Auth from './auth/reducer';
import Dashboard from './dashboard/reducer';
import Subscription from './subscriptions/reducer';
import Invoice from './invoices/reducer';
import User from './users/reducer';
import Affiliate from './affiliates/reducer';
import Commission from './commissions/reducer';
import DiscountCode from './discountCodes/reducer';

const rootReducer = combineReducers({
  Layout,
  Auth,
  Dashboard,
  Subscription,
  Invoice,
  User,
  Affiliate,
  Commission,
  DiscountCode,
});

export default rootReducer;
